import { render, staticRenderFns } from "./BillWrite.vue?vue&type=template&id=9702310a&scoped=true"
import script from "./BillWrite.vue?vue&type=script&lang=js"
export * from "./BillWrite.vue?vue&type=script&lang=js"
import style0 from "./BillWrite.vue?vue&type=style&index=0&id=9702310a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9702310a",
  null
  
)

export default component.exports